// チャット内の絵文字リアクションをしたユーザー一覧を表示するメニュー

import defaultUserIcon from '@src/assets/images/avatar/default.png';
import { ChannelMemberUserTypeEnum } from '@src/enum/ChannelMemberUserTypeEnum';
import { Emoji } from 'emoji-picker-react';
import React from 'react';

interface ReactionUserDropdownMenuProps {
  users?: {
    user_id?: number;
    display_name?: string;
    avatar_url?: string;
    user_type?: ChannelMemberUserTypeEnum;
  }[];
  emoji?: string;
}

const ReactionUserDropdownMenu: React.FC<ReactionUserDropdownMenuProps> = ({ users, emoji }) => {
  const DISPLAY_NAME_ELLIPSIS_THRESHOLD = 15;
  return (
    <div
      className='flex max-h-[200px] flex-col rounded border border-solid border-gray-400 bg-white'
      data-testid='reaction-user-dropdown-menu'
    >
      <div className='flex justify-center px-2 py-1 text-sm'>
        <Emoji
          unified={emoji?.toLowerCase() || ''}
          size={20}
        />
      </div>
      <div className='overflow-y-auto border-t border-solid border-gray-200 py-2.5'>
        {users?.map((user) => (
          <div
            className='flex items-center gap-4 truncate px-4 py-[2px]'
            key={user?.user_id}
          >
            <img
              src={user?.avatar_url ?? ''}
              onError={(e) => {
                e.currentTarget.src = defaultUserIcon;
                e.currentTarget.onerror = null;
              }}
              alt={user?.display_name}
              className='size-[28px] rounded-full object-cover'
            />
            <span className='truncate text-sm'>
              {user.display_name && user?.display_name?.length > DISPLAY_NAME_ELLIPSIS_THRESHOLD
                ? `${user.display_name?.slice(0, DISPLAY_NAME_ELLIPSIS_THRESHOLD)}...`
                : user.display_name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReactionUserDropdownMenu;
